module.exports = __webpack_public_path__ + "static/media/drop-23-2@1x.d7fbff94.png";